// @ts-nocheck
import {
  ADD_NON_TAXABLE_FAILURE,
  ADD_NON_TAXABLE_REQUEST,
  ADD_NON_TAXABLE_SUCCESS,
  ADD_REIMBURSEMENT_CONT_FAILURE,
  ADD_REIMBURSEMENT_CONT_REQUEST,
  ADD_REIMBURSEMENT_CONT_SUCCESS,
  ADD_REIMBURSEMENT_FAILURE,
  ADD_REIMBURSEMENT_REQUEST,
  ADD_REIMBURSEMENT_SUCCESS,
  CLOSE_DEDUCTION_MODAL,
  CLOSE_NON_TAXABLE_MODAL,
  CLOSE_REIMBURSEMENT_MODAL,
  GET_ALL_REIM_AND_DEDUC_OF_EVENT_FAILURE,
  GET_ALL_REIM_AND_DEDUC_OF_EVENT_REQUEST,
  GET_ALL_REIM_AND_DEDUC_OF_EVENT_SUCCESS,
  GET_DEDUCTION_CATEGORY_FAILURE,
  GET_DEDUCTION_CATEGORY_REQUEST,
  GET_DEDUCTION_CATEGORY_SUCCESS,
  GET_NON_TAXABLE_CATEGORY_FAILURE,
  GET_NON_TAXABLE_CATEGORY_REQUEST,
  GET_NON_TAXABLE_CATEGORY_SUCCESS,
  GET_REIMBURSEMENT_CATEGORY_FAILURE,
  GET_REIMBURSEMENT_CATEGORY_REQUEST,
  GET_REIMBURSEMENT_CATEGORY_SUCCESS,
  OPEN_DEDUCTION_MODAL,
  OPEN_NON_TAXABLE_MODAL,
  OPEN_REIMBURSEMENT_MODAL,
  REMOVE_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_FAILURE,
  REMOVE_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_REQUEST,
  REMOVE_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_SUCCESS,
  REMOVE_REIMBURSEMENT_OR_DEDUCTION_FAILURE,
  REMOVE_REIMBURSEMENT_OR_DEDUCTION_REQUEST,
  REMOVE_REIMBURSEMENT_OR_DEDUCTION_SUCCESS,
  UPDATE_REIMB_AND_DEDUCT_FAILURE,
  UPDATE_REIMB_AND_DEDUCT_REQUEST,
  UPDATE_REIMB_AND_DEDUCT_SUCCESS,
} from "../../constants/event/adjustments";

const initialState = {
  eventAdjustments: {
    allContractorsDetails: [],
    reimbursements: [],
    deductions: [],
    nonTaxableCharges: [],
  },
  adjustmentEventId: null,
  adjustmentRequestId: null,
  adjustmentLoadError: null,
  eaLoading: false, // event adjustment loading
  reimbursementCategories: [],
  rcLoading: false, // reimbursement category loading
  deductionCategories: [],
  dcLoading: false, // deduction category loading
  nonTaxableCategories: [],
  ntLoading: false, // non taxable loading
  delAccLoading: false, // remove reimbursement loading
  delCategoryLoading: false, // delete category loading
  arLoading: false, // add reimbursement loading

  // for right click wrapper
  adjustmentWrapper: {
    isReimbursement: false,
    isNonTax: false,
    taxCategory: null,
    open: false,
    contractorDetails: null,
    positionDetails: null,
    customNonTaxableCharges: null,
    openDraft: false,
  },
};

const adjustmentsReducer = (state = initialState, action) => {
  switch (action?.type) {
    case GET_REIMBURSEMENT_CATEGORY_REQUEST:
      return {
        ...state,
        rcLoading: true,
      };
    case GET_REIMBURSEMENT_CATEGORY_SUCCESS:
      return {
        ...state,
        rcLoading: false,
        reimbursementCategories: action?.payload,
      };
    case GET_REIMBURSEMENT_CATEGORY_FAILURE:
      return {
        ...state,
        rcLoading: false,
      };

    case GET_DEDUCTION_CATEGORY_REQUEST:
      return {
        ...state,
        dcLoading: true,
      };
    case GET_DEDUCTION_CATEGORY_SUCCESS:
      return {
        ...state,
        dcLoading: false,
        deductionCategories: action?.payload,
      };
    case GET_DEDUCTION_CATEGORY_FAILURE:
      return {
        ...state,
        dcLoading: false,
      };

    case GET_NON_TAXABLE_CATEGORY_REQUEST:
      return {
        ...state,
        ntLoading: true,
      };
    case GET_NON_TAXABLE_CATEGORY_SUCCESS:
      return {
        ...state,
        ntLoading: false,
        nonTaxableCategories: action?.payload,
      };
    case GET_NON_TAXABLE_CATEGORY_FAILURE:
      return {
        ...state,
        ntLoading: false,
      };

    case REMOVE_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_REQUEST:
      return {
        ...state,
        delCategoryLoading: true,
      };
    case REMOVE_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_FAILURE:
      return {
        ...state,
        delCategoryLoading: false,
      };
    case REMOVE_REIMBURSEMENT_AND_DEDUCTION_CATEGORY_SUCCESS:
      return {
        ...state,
        delCategoryLoading: false,
      };

    case GET_ALL_REIM_AND_DEDUC_OF_EVENT_REQUEST:
      return {
        ...state, eaLoading: true, adjustmentLoadError: null,
        adjustmentEventId: action.meta?.eventId ?? state.adjustmentEventId,
        adjustmentRequestId: action.meta?.requestId ?? state.adjustmentRequestId,
      };
    case GET_ALL_REIM_AND_DEDUC_OF_EVENT_SUCCESS:
      if (action.meta && (action.meta.requestId !== state.adjustmentRequestId || action.meta.eventId !== state.adjustmentEventId)) return state;
      if (action.meta && String(action.payload?.eventDetails?._id || '') !== action.meta.eventId) {
        return { ...state, eaLoading: false, adjustmentLoadError: 'The expense response does not match this show. Reload before invoicing.' };
      }
      return {
        ...state, eaLoading: false, adjustmentLoadError: null,
        eventAdjustments: {
          allContractorsDetails: action?.payload?.allContractorsDetails ?? [],
          reimbursements: action?.payload?.reimbursements ?? [],
          deductions: action?.payload?.deductions ?? [],
          nonTaxableCharges: action?.payload?.nonTaxableCharges ?? [],
        },
      };
    case GET_ALL_REIM_AND_DEDUC_OF_EVENT_FAILURE:
      if (action.meta && action.meta.requestId !== state.adjustmentRequestId) return state;
      return { ...state, eaLoading: false, adjustmentLoadError: action.error || 'Unable to refresh show expenses' };

    case REMOVE_REIMBURSEMENT_OR_DEDUCTION_REQUEST:
      return {
        ...state,
        delAccLoading: true,
      };
    case REMOVE_REIMBURSEMENT_OR_DEDUCTION_SUCCESS:
      return {
        ...state,
        delAccLoading: false,
      };
    case REMOVE_REIMBURSEMENT_OR_DEDUCTION_FAILURE:
      return {
        ...state,
        delAccLoading: false,
      };

    case ADD_REIMBURSEMENT_REQUEST:
      return {
        ...state,
        arLoading: true,
      };
    case ADD_REIMBURSEMENT_SUCCESS:
      return {
        ...state,
        arLoading: false,
      };
    case ADD_REIMBURSEMENT_FAILURE:
      return {
        ...state,
        arLoading: false,
      };

    case ADD_NON_TAXABLE_REQUEST:
      return {
        ...state,
        arLoading: true,
      };
    case ADD_NON_TAXABLE_SUCCESS:
      return {
        ...state,
        arLoading: false,
      };
    case ADD_NON_TAXABLE_FAILURE:
      return {
        ...state,
        arLoading: false,
      };

    case ADD_REIMBURSEMENT_CONT_REQUEST:
      return {
        ...state,
        arLoading: true,
      };
    case ADD_REIMBURSEMENT_CONT_SUCCESS:
      return {
        ...state,
        arLoading: false,
      };
    case ADD_REIMBURSEMENT_CONT_FAILURE:
      return {
        ...state,
        arLoading: false,
      };

    case UPDATE_REIMB_AND_DEDUCT_REQUEST:
      return {
        ...state,
        arLoading: true,
      };
    case UPDATE_REIMB_AND_DEDUCT_SUCCESS:
      return {
        ...state,
        arLoading: false,
      };
    case UPDATE_REIMB_AND_DEDUCT_FAILURE:
      return {
        ...state,
        arLoading: false,
      };

    // for wrapper of right click
    case OPEN_REIMBURSEMENT_MODAL:
      return {
        ...state,
        adjustmentWrapper: {
          isReimbursement: true,
          isNonTax: false,
          taxCategory: null,
          open: true,
          contractorDetails: action?.payload?.contractorDetails,
          positionDetails: action?.payload?.positionDetails,
          openDraft: action?.payload?.openDraft,
        },
      };

    case CLOSE_REIMBURSEMENT_MODAL:
      return {
        ...state,
        adjustmentWrapper: {
          isReimbursement: false,
          open: false,
          isNonTax: false,
          taxCategory: null,
          contractorDetails: null,
          positionDetails: null,
        },
      };

    case OPEN_DEDUCTION_MODAL:
      return {
        ...state,
        adjustmentWrapper: {
          isReimbursement: false,
          open: true,
          taxCategory: null,
          isNonTax: false,
          contractorDetails: action?.payload?.contractorDetails,
          positionDetails: action?.payload?.positionDetails,
          openDraft: action?.payload?.openDraft,
        },
      };

    case CLOSE_DEDUCTION_MODAL:
      return {
        ...state,
        adjustmentWrapper: {
          isNonTax: false,
          isReimbursement: false,
          taxCategory: null,
          open: false,
          contractorDetails: null,
          positionDetails: null,
        },
      };

    case OPEN_NON_TAXABLE_MODAL:
      return {
        ...state,
        adjustmentWrapper: {
          ...state?.adjustmentWrapper,
          isNonTax: true,
          taxCategory: action?.payload?.category,
          open: true,
          customNonTaxableCharges: action?.payload?.customList,
          hidePlus: action?.payload?.hidePlus,
          openDraft: action?.payload?.openDraft,
        },
      };

    case CLOSE_NON_TAXABLE_MODAL:
      return {
        ...state,
        adjustmentWrapper: {
          isNonTax: false,
          isReimbursement: false,
          taxCategory: null,
          open: false,
          contractorDetails: null,
          positionDetails: null,
          customNonTaxableCharges: null,
          hidePlus: false,
        },
      };

    default:
      return state;
  }
};

export default adjustmentsReducer;
export { initialState };